var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlooWordmarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 41,
    viewBox: "0 0 80 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.726 0.5H25.6035V30.571H29.726V0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.212 27.3412C40.3346 27.3412 37.5491 24.2861 37.5491 20.489C37.5491 16.801 40.3123 13.7677 44.212 13.7677C48.0226 13.7677 50.7412 16.8228 50.7412 20.489C50.7412 24.2861 48.0226 27.3412 44.212 27.3412ZM44.212 10.0361C38.0394 10.0361 33.4043 14.7279 33.4043 20.489C33.4043 26.3373 38.0171 31.0728 44.212 31.0728C50.2955 31.0728 54.886 26.3373 54.886 20.489C54.886 14.7279 50.3178 10.0361 44.212 10.0361Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4562 27.3412C64.5787 27.3412 61.7932 24.2861 61.7932 20.489C61.7932 16.801 64.5565 13.7677 68.4562 13.7677C72.2667 13.7677 74.9853 16.8228 74.9853 20.489C74.9853 24.2861 72.2667 27.3412 68.4562 27.3412ZM68.4562 10.0361C62.2835 10.0361 57.6484 14.7279 57.6484 20.489C57.6484 26.3373 62.2612 31.0728 68.4562 31.0728C74.5397 31.0728 79.1302 26.3373 79.1302 20.489C79.1302 14.7279 74.562 10.0361 68.4562 10.0361Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.489C0 26.3373 4.63506 31.0728 10.8077 31.0728C13.3258 31.0728 15.5542 30.2653 17.3369 28.9124V30.3745C17.3369 35.0662 14.9971 36.7247 10.7186 36.7247L10.7631 40.5C16.0667 40.5 21.4372 38.7106 21.4372 29.4579V10.2107H17.5375L17.3592 12.1747C15.5765 10.8436 13.3258 10.0361 10.83 10.0361C4.63506 10.0361 0 14.7279 0 20.489ZM10.8077 27.3412C6.90802 27.3412 4.14481 24.2861 4.14481 20.489C4.14481 16.801 6.90802 13.7677 10.8077 13.7677C14.6183 13.7677 17.3369 16.8228 17.3369 20.489C17.3369 24.3079 14.6183 27.3412 10.8077 27.3412Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlooWordmarkWhite);
export default __webpack_public_path__ + "static/media/Gloo_Wordmark_White.25497321ce4af71a5b814a1b0e23a4bc.svg";
export { ForwardRef as ReactComponent };